import { useState, useEffect } from 'react';
import { organizationRouter } from '../services/organizationRouter';
import { Farm } from '../../../services/farm/farmService';

// Pure data hook - Database Domain only
export const useOrganizationSearch = () => {
  const [organizations, setOrganizations] = useState<Farm[]>([]);
  const [recentOrganizations, setRecentOrganizations] = useState<Farm[]>([]);
  const [favoriteOrganizations, setFavoriteOrganizations] = useState<Farm[]>([]);
  const [loading, setLoading] = useState(false);
  const [error, setError] = useState<string | null>(null);

  // Database operations only
  const searchByName = async (name: string, userId?: string): Promise<Farm[]> => {
    try {
      setLoading(true);
      const results = await organizationRouter.searchByName(name, 'farm', userId);
      setOrganizations(results);
      return results;
    } catch (err) {
      setError(err instanceof Error ? err.message : 'Search failed');
      return [];
    } finally {
      setLoading(false);
    }
  };

  const loadRecent = async (): Promise<Farm[]> => {
    const results = await organizationRouter.getRecentOrganizations();
    setRecentOrganizations(results);
    return results;
  };

  const loadFavorites = async (): Promise<Farm[]> => {
    const results = await organizationRouter.getFavoriteOrganizations();
    setFavoriteOrganizations(results);
    return results;
  };

  return {
    // Data only
    organizations,
    recentOrganizations,
    favoriteOrganizations,
    loading,
    error,
    // Database operations only
    searchByName,
    loadRecent,
    loadFavorites
  };
};